import { render, staticRenderFns } from "./VProjectActionCategoryForm.vue?vue&type=template&id=4433264c&"
import script from "./VProjectActionCategoryForm.vue?vue&type=script&lang=js&"
export * from "./VProjectActionCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports